import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'YagiofferDownloadItem',
  props: {
    formatId: null,
    isSendYagiPostEnabled: { type: Boolean },
    isSendYagiEmailEnabled: { type: Boolean },
    mailPdfEnabled: { type: Boolean },
    downloadPdfEnabled: { type: Boolean },
    downloadActiveCollapses: null
  },
  setup(__props: any) {

const props = __props as {
  formatId?: string
  isSendYagiPostEnabled?: boolean
  isSendYagiEmailEnabled?: boolean
  mailPdfEnabled?: boolean
  downloadPdfEnabled?: boolean
  downloadActiveCollapses?: unknown[]
};



const facebookPortalUrl =
  'http://www.facebook.com/share.php?u=https://portal.yagish.jp/career_yagioffer/'
const twPortalUrl =
  'https://twiter.com/share?url=https://portal.yagish.jp/career_yagioffer/'

console.error(props.formatId)

return { __sfc: true,props, facebookPortalUrl, twPortalUrl }
}

})